import controller_fun from "@/libs/controller/controller_fun";
/**登录 */
import login from "@/libs/controller/login";
/**公共 */
import common from "@/libs/controller/common";
/**用户 */
import user from "@/libs/controller/user";
/**传统校 */
import school from "@/libs/controller/school";
/**俱乐部 */
import club from "@/libs/controller/club";
/**后备人才 */
import base from "@/libs/controller/base";
/**培训班 */
import coache from "@/libs/controller/coache";
/**赛事 */
import game from "@/libs/controller/game";
/**足球 */
import football from "@/libs/controller/football";
/**赛事名录 */
import directory from "@/libs/controller/directory";
/**人才培养基地管理 */
import cultivate from "@/libs/controller/cultivate";
/**字典 */
import dict from "@/libs/controller/dict";
/**省市体育局管理*/
import sports from "@/libs/controller/sports";
/**导出 */
import exports from "@/libs/controller/export";
// 赛事备案管理
import record from "@/libs/controller/record";
const controller = {
  ...common,
  ...login,
  ...user,
  ...school,
  ...club,
  ...base,
  ...coache,
  ...game,
  ...football,
  ...directory,
  ...cultivate,
  ...dict,
  ...sports,
  ...record,
  ...exports
};
Object.assign(controller, controller_fun);
export default controller;
